
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.49265 15.2457C6.49265 7.78578 12.5401 1.73834 20 1.73834C27.4598 1.73834 33.5073 7.78577 33.5073 15.2457V28.528C33.5073 29.3564 32.8357 30.028 32.0073 30.028H7.99265C7.16422 30.028 6.49265 29.3564 6.49265 28.528V15.2457Z","fill":"#5D5CFD"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.29859 26.6945C3.37812 26.6945 2.63193 27.4407 2.63193 28.3612C2.63193 29.2817 3.37812 30.0279 4.29859 30.0279H35.7013C36.6218 30.0279 37.368 29.2817 37.368 28.3612C37.368 27.4407 36.6218 26.6945 35.7013 26.6945H4.29859ZM17.4494 35.7109C17.4494 37.1195 18.5913 38.2615 20 38.2615C21.4087 38.2615 22.5506 37.1195 22.5506 35.7109V35.5068C22.5506 34.0981 21.4087 32.9562 20 32.9562C18.5913 32.9562 17.4494 34.0981 17.4494 35.5068V35.7109Z","fill":"#16171F"}})])
          )
        }
      }
    